<template>
  <div class="activeity">
    <Header></Header>
    <div class="img-box">
      <img src="@/assets/img/pc/activeity/advertis_1.png" alt="">
      <img src="@/assets/img/pc/activeity/advertis_2.png" alt="">
      <img src="@/assets/img/pc/activeity/advertis_3.png" alt="">
    </div>
  </div>
</template>

<script>
import Header from '@/components/pc/header'
import Footer from '@/components/pc/footer'
export default {
  components: {
    Header
  }
}
</script>

<style lang="less">
  .activeity {
    background: linear-gradient(135deg, #000d3b 1%,#011b64 100%);
    .img-box {
      overflow: hidden;
      img {
        display: block;
        margin: 0 auto;
      }
    }
  }
</style>
